import axios from 'axios';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { ButtonGroup, Col, Form, Image, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import SlidingPane from "react-sliding-pane";
import Button from '../../../../shared/components/Button';
import Dropzone from '../../../../shared/components/Dropzone/Dropzone';
import FormControl from '../../../../shared/components/Form/FormControl';
import useBreakpoint from '../../../../shared/hooks/useBreakpoint';

const UploadInsightSidePane = ({
  isPaneOpen,
  onRequestClose,
  userPost: { id, thumb_url:thumbUrl, caption, story, platform, is_inst_story_likes_enabled },
  userOfferId
}) => {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  if (platform !== 'instagram') return <div></div>;

  const exampleScreenshotPath = require('../../../../../frontend/images/media-stats-example.png');

  const [state, setState] = useState({
    loading: false,
    success: false
  });

  const params = (values) => {
    let userPost = {};
    let selfReportedStats = {};

    values.impressions && (selfReportedStats.impressions = { count: parseInt(values.impressions) });
    values.replies && (selfReportedStats.replies = { count: parseInt(values.replies) });
    values.swipeUps && (selfReportedStats.swipe_ups = { count: parseInt(values.swipeUps) });
    values.likes && (selfReportedStats.likes = { count: parseInt(values.likes) });

    if (Object.keys(selfReportedStats).length > 0) {
      userPost.self_reported_stats = selfReportedStats;
    }

    if (values.file) {
      userPost.self_reported_stats_url = values.file;
    }

    return userPost;
  };

  const formik = useFormik({
    initialValues: {
      file: '',
      impressions: '',
      replies: '',
      swipeUps: '',
      likes: ''
    },
    onSubmit: values => {
      setState({ loading: true });
      axios.put(`/api/v1/influencers/user_offers/${userOfferId}/user_posts/${id}`, {
        user_post: params(values)
      }).then(({ data }) => {
        if (data.success) {
          setState({ ...state, success: true });
          window.location.reload(true);
        } else {
          throw 'Something went wrong!';
        }
      }).catch(() => {
        setState({ ...state, success: false, loading: false });
      }).finally(() => {
        onRequestClose();
      });
    },
  });

  return (
    <div>
      <SlidingPane
        hideHeader
        isOpen={isPaneOpen}
        width={breakpoint !== 'xs' ? '375px' : '100%'}
        shouldCloseOnEsc
        onRequestClose={onRequestClose}
      from={document.body.dir === 'ltr' ? 'right' : 'left'}
      >
        {!story &&
          <Fragment>
            {breakpoint !== 'xs' ?
              <h3 className="mb-4-5">
                {t('influencers.pages.campaign.upload_insight_side_pane.subtitle')}
              </h3> :
              <h4 className="mb-4-5">
                {t('influencers.pages.campaign.upload_insight_side_pane.subtitle')}
              </h4>
            }
          </Fragment>
        }
        {breakpoint !== 'xs' ?
          <Fragment>
            {story ?
              <h3 className="mb-3">
                {t('influencers.pages.campaign.upload_insight_side_pane.title')}
              </h3> :
              <h4 className="mb-3">
                {t('influencers.pages.campaign.upload_insight_side_pane.title')}
              </h4>
            }
          </Fragment> :
          <Fragment>
            {story ?
              <h4 className="mb-3">
                {t('influencers.pages.campaign.upload_insight_side_pane.title')}
              </h4> :
              <h5 className="mb-3">
                {t('influencers.pages.campaign.upload_insight_side_pane.title')}
              </h5>
            }
          </Fragment>
        }

        {story ?
          <p className='mb-5'>
            {t('influencers.pages.campaign.upload_insight_side_pane.desc')}
          </p> :
          <p className='mb-5'>
            <a
              href={exampleScreenshotPath}
              target="_blank"
            >
              {t('influencers.pages.campaign.upload_insight_side_pane.ex_ss')}
            </a> ({t('influencers.pages.campaign.upload_insight_side_pane.ex_ss_desc')})
          </p>
        }

        <Form onSubmit={formik.handleSubmit}>
          {story ?
            <Fragment>
              <Form.Group>
                <Form.Label>
                  {t('influencers.pages.campaign.upload_insight_side_pane.stats.impressions')}
                </Form.Label>
                <FormControl
                  type="text"
                  placeholder="Text"
                  name='impressions'
                  {...formik.getFieldProps('impressions')}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>
                  {t('influencers.pages.campaign.upload_insight_side_pane.stats.swipe_ups')}
                </Form.Label>
                <FormControl
                  type="text"
                  placeholder="Text"
                  name='swipeUps'
                  {...formik.getFieldProps('swipeUps')}
                />
              </Form.Group>

              <Form.Group>
                <Form.Label>
                  {t('influencers.pages.campaign.upload_insight_side_pane.stats.replies')}
                </Form.Label>
                <FormControl
                  type="text"
                  placeholder="Text"
                  name='replies'
                  {...formik.getFieldProps('replies')}
                />
              </Form.Group>

              {
                is_inst_story_likes_enabled &&
                <Form.Group>
                  <Form.Label>
                    {t('influencers.pages.campaign.upload_insight_side_pane.stats.likes')}
                  </Form.Label>
                  <FormControl
                    type="text"
                    placeholder="Text"
                    name='replies'
                    {...formik.getFieldProps('likes')}
                  />
                </Form.Group>
              }
            </Fragment> :
            <Fragment>
              <Image fluid src={formik.values.file} />
              <Dropzone
                name='file'
                onChange={(_, mediaUpload) => {
                  if (mediaUpload.success) {
                    formik.setFieldValue('file', mediaUpload.fileUrl);
                  }
                }}
                selectFiles
              />
            </Fragment>
          }
          <div className="my-6"><hr /></div>

          {breakpoint !== 'xs' ?
            <h4 className="mb-4">
              {t('influencers.pages.campaign.upload_insight_side_pane.reference_post')}
            </h4> :
            <h5 className="mb-4">
              {t('influencers.pages.campaign.upload_insight_side_pane.reference_post')}
            </h5>
          }

          <Col xs={5} className='p-0 mb-3'>
            <Image className="w-100" rounded src={thumbUrl} />
          </Col>

          <p>{caption}</p>

          <div className="my-6"><hr /></div>

          <Row className='justify-content-end'>
            <Col className="col-auto">
              <ButtonGroup className="non-adaptable">
                <Button
                  variant="secondary"
                  type="button"
                  disabled={state.loading}
                  onClick={() => onRequestClose()}>
                  {t('influencers.common.cancel')}
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={
                    (state.loading || !formik.dirty)
                  }
                >
                  {state.loading
                    ? <Spinner animation="border" size="sm" />
                    : t('influencers.common.save')
                  }
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </Form>
      </SlidingPane>
    </div>
  );
};

UploadInsightSidePane.propTypes = {
  isPaneOpen: PropTypes.bool,
  onRequestClose: PropTypes.func.isRequired,
  userPost: PropTypes.object.isRequired,
  userOfferId: PropTypes.number.isRequired
};

UploadInsightSidePane.defaultProps = {
  isPaneOpen: false,
};

export default UploadInsightSidePane;
